
const productSliderV1Override = {
  spaceBetween: 40,
  slidesPerView: 2,
  centeredSlides: true,
  loop: true,
  // Responsive breakpoints
  breakpoints: {
    // when window width is >= 768px
    767: {
      slidesPerView: 4,
      spaceBetween: 20
    },
    // when window width is >= 1200px
    1200: {
      slidesPerView: 6,
      spaceBetween: 40
    }
  },
  pagination: {
    el: ".js_product_slider_v1_pagination .swiper-pagination",
    clickable: true,
    dynamicBullets: false,
  },
  navigation: {
    nextEl: ".js_product_slider_v1_nav .swiper-button-next",
    prevEl: ".js_product_slider_v1_nav .swiper-button-prev",
  },
};
window.productSliderV1Override = productSliderV1Override;

